import apiClient from '@/apiClient';

export default {
  state: () => ({
    text: '', // Текст после эскизов и расчета
    contacts: '', // Контакты компании
    showSketches: false, // Приложить к письму эскизы каркаса и дверей шкафа
    showPrices: false // Указать в письме расчетную стоимость шкафа
  }),

  mutations: {
    notificationSettingsData: (state, payload) => {
      state.text = payload.text;
      state.contacts = payload.contacts;
      state.showSketches = Boolean(payload.showSketches);
      state.showPrices = Boolean(payload.showPrices);
    }
  },

  actions: {
    loadNotificationSettings: ({ commit }) =>
      new Promise((resolve, reject) => {
        apiClient
          .get(`/notifications/orders/settings`)
          .then(resp => {
            commit('notificationSettingsData', resp.data);
            resolve(resp);
          })
          .catch(error => {
            reject(error);
          });
      }),

    updateNotificationSettings: ({ state }, payload) =>
      new Promise((resolve, reject) => {
        console.log(payload);
        apiClient
          .put(`/notifications/orders/settings`, payload)
          .then(resp => {
            resolve(resp);
          })
          .catch(error => {
            reject(error);
          });
      })
  }
};
